const marketAnalyse = ()=>import('@/view/marketAnalysis')
//营销看板
const marketBoard = ()=>import('@/view/marketAnalysis/marketBoard.vue')
//优惠券分析
const discountCoupon = ()=>import('@/view/marketAnalysis/discountCoupon.vue')
//活动分析
const activity = ()=>import('@/view/marketAnalysis/activity.vue')
//触达渠道分析
const reach = ()=>import('@/view/marketAnalysis/reach.vue')
//渠道分析
const details = ()=>import('@/view/marketAnalysis/details.vue')

let router = [
    {
        path:'/marketAnalyse',
        component:marketAnalyse,
        name: 'marketAnalyse',
        redirect: '/marketAnalyse/marketBoard',
        meta:{
            menuTitle: "营销分析",
            menuKey: 'marketAnalyse', 
            menuIcon: 'icon-report-form',
        },
        children:[
            {
                path: 'marketBoard',
                component: marketAnalyse,
                name: 'marketBoard',
                redirect: '/marketAnalyse/marketBoard',
                meta: {
                    menuKey: "marketAnalyse",
                    menuTitle: "营销看板",
                    menuIcon: "icon-marketing-board",
                },
                children:[
                    {
                        path: '/marketAnalyse/marketBoard',
                        component: marketBoard,
                        name: 'marketBoard',
                        meta: {
                            menuKey: "marketAnalyse",
                            menuTitle: "营销看板",
                            menuIcon: "el-icon-chat-dot-round",
                        }
                    }
                ]
            },
            {
                path: 'marketBoard',
                component: marketAnalyse,
                name: 'marketBoard',
                meta: {
                    menuKey: "marketAnalyse",
                    menuTitle: "营销数据",
                    menuIcon: "icon-marketing-data",
                },
                children:[
                    {
                        path: '/marketAnalyse/discountCoupon',
                        component: discountCoupon,
                        name: 'discountCoupon',
                        meta: {
                            menuKey: "marketAnalyse",
                            menuTitle: "优惠券分析",
                            menuIcon: "el-icon-chat-dot-round",
                        }
                    },
                    {
                        path: '/marketAnalyse/activity',
                        component: activity,
                        name: 'activity',
                        meta: {
                            menuKey: "marketAnalyse",
                            menuTitle: "活动分析",
                            menuIcon: "el-icon-chat-dot-round",
                        }
                    },
                    {
                        path: '/marketAnalyse/reach',
                        component: reach,
                        name: 'reach',
                        meta: {
                            menuKey: "marketAnalyse",
                            menuTitle: "触达渠道分析",
                            menuIcon: "el-icon-chat-dot-round",
                        }
                    },
                    {
                        path: '/marketAnalyse/details',
                        component: details,
                        name: 'details',
                        meta: {
                            menuKey: "marketAnalyse",
                            secondMenuKey: 'marketBoard'
                        }
                    },
                ]
            }
        ]
    }
]

export default router